import { Alert } from "@material-ui/lab";
import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  infoAlert: {
    "& .MuiAlert-icon": {
      color: "#B8E7FB",
    },
    marginTop: "30px",
    backgroundColor: "#233145",
  },
})

const AlertUnitImagesEmpty = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <Alert className={classes.infoAlert} severity="info">
      {t('imagesPage_No_pictures_available')}
    </Alert>
  )
}

export default AlertUnitImagesEmpty
